export default {

  /**
   * @returns {Object}
   */
  getMinutesSlider() {
    return {
      label: 'minutes',
      val: 75,
      thumbSize: 26,
      min: 5,
      max: 90,
      color: 'orange darken-3',
    };
  },

  getRoutes(state) {
    return state.routes.items.map(route => ({
      id: route.id,
      type: route.type ? route.type : null,
      name: `${route.origin} - ${route.destination}`,
    }));
  },

  getRouteTexts(state) {
    return state.routes.texts.items;
  },

  getRouteTags(state) {
    return state.routes.texts.tags;
  },

  getSeasons(state) {
    const selectedRouteId = state.prices.route;
    const routes = Object.values(state.routes.items);
    if (selectedRouteId && routes) {
      const selectedRoute = routes.find(route => route.id === selectedRouteId);
      if (selectedRoute && selectedRoute.type && selectedRoute.type === 'train') {
        return [...state.prices.season.items].sort(
          (a, b) => (a.startedAt < b.endedAt ? 1 : -1),
        );
      }
    }

    return [...state.prices.season.items].sort(
      (a, b) => (a.startDate < b.startDate ? 1 : -1),
    );
  },

  getSeasonPrice(state) {
    if (!state.prices.season.prices.item) {
      return null;
    }
    const seasonPrices = { ...state.prices.season.prices.item };
    delete seasonPrices.seasonId;

    return seasonPrices;
  },

  getSeasonDepartures(state) {
    const departures = state.departures.items;
    const ferries = state.ferries.items;
    if (!departures || !ferries) {
      return null;
    }
    return departures.map((departure) => {
      const ferry = ferries.find(
        stateFerry => stateFerry.id === departure.ferryId,
      );
      return {
        ...departure,
        ferry,
      };
    });
  },

  getSeasonPriceCategories() {
    return [
      {
        categoryProperty: 'personCategoryPrices',
        label: 'Persons',
        typeProperty: 'personCategory',
      },
      {
        categoryProperty: 'carTypePrices',
        label: 'Cars',
        typeProperty: 'carType',
      },
      {
        categoryProperty: 'cabinPrices',
        label: 'Cabins',
        typeProperty: 'cabin',
      },
      {
        categoryProperty: 'extraPrices',
        label: 'Extras',
        typeProperty: 'extra',
      },
    ];
  },

  getExtraHeaders() {
    return [
      { text: '#', sortable: false, width: '30px', class: 'px-2', value: '' },
      { text: 'Name', class: 'px-2', value: 'name' },
      { text: 'Website name', class: 'px-2', value: 'webName' },
      { text: 'External ref.', class: 'px-2', value: 'externalRef' },
      { text: 'Active', width: '70px', class: 'px-2', value: 'active' },
      { text: 'Actions', width: '70px', sortable: false, class: 'px-2', value: '' },
    ];
  },

  getDepartureCabinsWithPrices(state) {
    const availableCabins = state.departures.cabins.items;
    const seasonPrices = state.departures.cabins.prices;
    const priceCabins = [];

    if (state.departures.cabins.loading) {
      return [];
    }

    availableCabins.forEach((cabin) => {
      if (seasonPrices.length) {
        const price = seasonPrices.find(cabinPrice => cabin.id === cabinPrice.entityId);

        if (price) {
          priceCabins.push({
            cabinName: cabin.name,
            ...price,
          });
        } else {
          priceCabins.push({
            cabinName: cabin.name,
            id: null,
            entityId: cabin.id,
            grossPrice: '',
            netPrice: '',
          });
        }
      } else {
        priceCabins.push({
          cabinName: cabin.name,
          name: cabin.name,
          id: null,
          entityId: cabin.id,
          grossPrice: '',
          netPrice: '',
        });
      }
    });

    return priceCabins;
  },

  getDepartureExtrasWithPrices(state) {
    const availableExtras = state.departures.extras.items;
    const seasonPrices = state.departures.extras.prices;
    const priceExtras = [];

    if (state.departures.extras.loading) {
      return [];
    }

    availableExtras.forEach((extra) => {
      if (seasonPrices.length > 0) {
        const price = seasonPrices.find(extraPrice => extra.id === extraPrice.entityId);

        if (price) {
          priceExtras.push({
            extraName: extra.name,
            ...price,
          });
        } else {
          priceExtras.push({
            extraName: extra.name,
            id: null,
            entityId: extra.id,
            grossPrice: '',
            netPrice: '',
          });
        }
      } else {
        priceExtras.push({
          extraName: extra.name,
          name: extra.name,
          id: null,
          entityId: extra.id,
          grossPrice: '',
          netPrice: '',
        });
      }
    });

    return priceExtras;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/transportation/getters.js